// 项目常量配置
export default class AppConstants {
  /**
   * 通过值获取名字
   * @param code 具体值
   * @param typeList  要查找的数据列表
   * @returns {string|*}
   */
  static getTypeName(code, typeList) {
    if (typeList && typeList.length > 0) {
      for (let i = 0, len = typeList.length; i < len; i++) {
        if (code == typeList[i].code) {
          return typeList[i].name
        }
      }
    }
    return undefined
  }

  /**
   * 商品类型
   */
  static getProductTypeList() {
    return [{
      name: '门票',
      code: 1
    },
      {
        name: '酒店',
        code: 2
      },
      {
        name: '签证',
        code: 3
      },
      {
        name: '景酒',
        code: 4
      },
      {
        name: '百货',
        code: 5
      },
      {
        name: '抢购',
        code: 8
      },
      {
        name: '出境跟团',
        code: 73
      },
      {
        name: '国内跟团',
        code: 74
      },
      {
        name: '自由行',
        code: 75
      }
    ]
  }

  /**
   * 订单状态
   */
  static getOrderStatus() {
    return [{
      name: '待支付',
      code: 1
    },
      {
        name: '已支付',
        code: 2
      },
      {
        name: '取消支付',
        code: 3
      },
      {
        name: '支付失败',
        code: 4
      }
    ]
  }

  /**
   * 商品来源
   * @returns {({code: null, name: string}|{code: number, name: string}|{code: number, name: string}|{code: number, name: string})[]}
   */
  static getProductSources() {
    return [{
      name: '自有商品',
      code: 0
    },
      {
        name: '平台直采',
        code: 1
      },
      {
        name: '云仓分销',
        code: 2
      }
    ]
  }

  /**
   * 用户标签类型 1手动 2自动
   */
  static getUserTagType() {
    return [{
      name: '手动标识',
      code: 1
    },
      {
        name: '自动标识',
        code: 2
      }
    ]
  }

  /**
   * 用户标签规则类型 1.按订单支付笔数,2.按支付金额,3.按访问频率,4.按支付客单价,5.按支付频率
   */
  static getUserTagRuleType() {
    return [{
      name: '按订单支付笔数',
      code: 1
    },
      {
        name: '按交易金额',
        code: 2
      },
      {
        name: '按访问频率',
        code: 3
      },
      {
        name: '按支付客单价',
        code: 4
      },
      {
        name: '按支付频率',
        code: 5
      }
    ]

  }

  /**
   * 内容类型
   * @returns {({code: null, name: string}|{code: number, name: string}|{code: number, name: string}|{code: number, name: string})[]}
   */
  static getModularContentType() {
    return [{
      name: '商品',
      code: 0
    },
      {
        name: '链接',
        code: 1
      }
    ]
  }

  /**
   * 性别 1男 0女
   */
  static getSexType() {
    return [{
      name: '未知',
      code: 0
    },
      {
        name: '男',
        code: 1
      },
      {
        name: '女',
        code: 2
      }
    ]
  }

  /**
   * 用户详情类型 0禁用 1正常
   */
  static getUserDetailType() {
    return [{
      name: '禁用',
      code: 0
    },
      {
        name: '正常',
        code: 1
      }
    ]
  }

  /**
   * 用户标签状态 0未关联 1已关联
   */
  static getTagStatus() {
    return [{
      name: '未关联',
      code: 0
    },
      {
        name: '已关联',
        code: 1
      }
    ]
  }

  /**
   * 图标类型
   * @returns {({code: null, name: string}|{code: number, name: string}|{code: number, name: string}|{code: number, name: string})[]}
   */
  static getIconContentType() {
    return [{
      name: '商品类目',
      code: 0
    },
      {
        name: '商品',
        code: 1
      },
      {
        name: '链接',
        code: 2
      },
      {
        name: '小程序',
        code: 4
      },
      {
        name: '主题/子类目',
        code: 5
      },
      {
        name: '视频号',
        code: 6
      }
    ]
  }

  /**
   * 图标状态
   * @returns {({code: null, name: string}|{code: number, name: string}|{code: number, name: string}|{code: number, name: string})[]}
   */
  static getIconStatusType() {
    return [{
      name: '隐藏',
      code: 0
    },
      {
        name: '显示',
        code: 1
      }
    ]
  }

  /**
   * 最全商品类型
   */
  static getAllProductTypeList() {
    return [{
      name: '门票',
      code: 1
    },
      {
        name: '酒店',
        code: 2
      },
      {
        name: '签证',
        code: 3
      },
      {
        name: '景酒',
        code: 4
      },
      {
        name: '百货',
        code: 5
      },
      {
        name: '国内机票',
        code: 6
      },
      {
        name: '火车票',
        code: 7
      },
      {
        name: '抢购',
        code: 8
      },
      {
        name: '出境跟团',
        code: 73
      },
      {
        name: '国内跟团',
        code: 74
      },
      {
        name: '自由行',
        code: 75
      },
      {
        name: '国内游',
        code: 76
      },
      {
        name: '本地游',
        code: 77
      },
      {
        name: '定制游',
        code: 80
      },
      {
        name: '一日游',
        code: 81
      },
      {
        name: '预约',
        code: 83
      }
    ]
  }

  /**
   * 查询出数据权限(1:全部数据 2:仅账号下数据)
   * @returns {({code: number, name: string}|{code: number, name: string})[]}
   */
  static getDataPermissions() {
    return [{
      name: '全部数据',
      code: 1
    },
      {
        name: '账号数据',
        code: 2
      }
    ]
  }

  //: 二级分销商审核。0待审核，1审核通过，2审核不通过 ,
  static getStaffAuditList() {
    return [{
      name: '待审核',
      code: 0
    },
      {
        name: '审核通过',
        code: 1
      },
      {
        name: '审核不通过',
        code: 2
      }
    ]
  }

  //二级分销商 状态 0禁用 1启用 3已删除
  static getStaffStatusList() {
    return [{
      name: '禁用',
      code: 0
    },
      {
        name: '启用',
        code: 1
      },
      {
        name: '已删除',
        code: 2
      }
    ]
  }

  //收支类别 0全部 1总店佣金 2分店收入 3佣金退款 4佣金提现 ,
  static getIncomeAndExpenditureCategories() {
    return [{
      name: '全部',
      code: 0
    },
      {
        name: '总店佣金',
        code: 1
      },
      {
        name: '分店收入',
        code: 2
      },
      {
        name: '佣金退款',
        code: 3
      },
      {
        name: '佣金提现',
        code: 4
      }
    ]
  }

  // 资金流向 0全部 1收入 2支出
  static getCapitalFlow() {
    return [{
      name: '全部',
      code: 0
    },
      {
        name: '收入',
        code: 1
      },
      {
        name: '支出',
        code: 2
      }
    ]
  }

  // 商品下架原因；0手动下架；1库存不足；2运营商(供)商品更新；3价格过期；4.全部
  static getProInfoDropReason() {
    return [{
      name: '手动下架',
      code: 0
    },
      {
        name: '库存不足',
        code: 1
      },
      {
        name: '运营商(供)商品更新',
        code: 2
      },
      {
        name: '价格过期',
        code: 3
      },
      {
        name: '服务过期',
        code: 4
      }
    ]
  }

  //提现方式 (转帐方式): ，0：默认，1：支付宝，2：微信，3：银联
  static getTransferModes() {
    return [
      // {name:'默认',code:0},
      {
        name: '支付宝',
        code: 1
      },
      {
        name: '微信',
        code: 2
      },
      {
        name: '银联',
        code: 3
      }
    ]
  }

  //余额充值结果
  static getRechargeResult() {
    return [{
      name: '未支付',
      code: 0
    },
      {
        name: '充值成功',
        code: 1
      },
      {
        name: '充值失败',
        code: 2
      }
    ]
  }

  //余额转账方式
  static getTransferType() {
    return [{
      name: '线下转账',
      code: 1
    },
      {
        name: '在线充值',
        code: 2
      }
    ]
  }

  //资金流向
  static getCapitalFlowsType() {
    return [{
      name: '收入',
      code: 1
    },
      {
        name: '支出',
        code: 2
      }
    ]
  }

  //收入类别
  static getIncomeType() {
    return [{
      name: '前端销售',
      code: 1
    },
      {
        name: '充值',
        code: 2
      },
      {
        name: '保险搭售',
        code: 3
      },
      {
        name: '补差',
        code: 4
      }
    ]
  }

  //支出类别
  static getExpendType() {
    return [{
      name: '提现',
      code: 2
    },
      {
        name: '退款',
        code: 3
      },
      {
        name: '退款补差',
        code: 4
      }
    ]
  }

  //收支全类型
  static getIncomeExpendType() {
    return [{
      name: '前端销售',
      code: 1
    },
      {
        name: '充值',
        code: 2
      },
      {
        name: '保险搭售',
        code: 3
      },
      {
        name: '补差',
        code: 4
      },
      {
        name: '提现',
        code: 5
      },
      {
        name: '退款',
        code: 6
      },
      {
        name: '退款补差',
        code: 7
      }
    ]
  }

  //对账状态
  static getStatementStatus() {
    return [{
      name: '未出账',
      code: 1
    },
      {
        name: '待平台确认',
        code: 2
      },
      {
        name: '已确认',
        code: 3
      }
    ]
  }

  //已提交申请状态
  static getApplyStatus() {
    return [{
      name: '申请已提交',
      code: 0
    },
      {
        name: '已转账',
        code: 1
      },
      {
        name: '申请未通过',
        code: 2
      }
    ]
  }

  //文件装填
  static getFileTypeStatus() {
    return [{
      name: '文件待生成',
      code: 0
    },
      {
        name: '文件已生成',
        code: 1
      },
      {
        name: '文件已下载',
        code: 2
      },
      {
        name: '文件已删除',
        code: 100
      }
    ]
  }

  //文件装填
  static getFileRecordTypeStatus() {
    return [{
      name: '文件待生成',
      code: 1
    },
      {
        name: '文件已生成',
        code: 2
      },
      {
        name: '下载',
        code: 3
      },
      {
        name: '文件已删除',
        code: 100
      }
    ]
  }

  //调账类型
  static getAccountRegulationType() {
    return [{
      name: '商品贷款',
      code: 1
    },
      {
        name: '分销佣金',
        code: 2
      },
      {
        name: '其他',
        code: 3
      }
    ]
  }

  //授信还款状态 0表示未审核，1表示已审核，2表示已驳回
  static getCreditPaymentType() {
    return [{
      name: '未审核',
      code: 0
    },
      {
        name: '已审核',
        code: 1
      },
      {
        name: '已驳回',
        code: 2
      }
    ]
  }

  //预约订单状态   订单状态:0已确认1未确认2商家已拒绝3已关闭4申请退款5分销商同意退款6供应商同意退款7供应商拒绝退款8已退款(最终状态)9拒绝退款(最终状态)
  static getPreOrderStates() {
    return [{
      name: '已确认',
      code: 0
    },
      {
        name: '未确认',
        code: 1
      },
      {
        name: '商家已拒绝',
        code: 2
      },
      {
        name: '已关闭',
        code: 3
      },
      {
        name: '申请退款',
        code: 4
      },
      {
        name: '分销商同意退款',
        code: 5
      },
      {
        name: '供应商同意退款',
        code: 6
      },
      {
        name: '供应商拒绝退款',
        code: 7
      },
      {
        name: '已退款(最终状态)',
        code: 8
      },
      {
        name: '拒绝退款(最终状态)',
        code: 9
      }
    ]
  }

  /**
   * 游客信息列表
   */
  static getTouristInfoList() {
    return [{
      name: '身份证号',
      code: '1'
    },
      {
        name: '护照',
        code: '2'
      },
      {
        name: '港澳通行证',
        code: '3'
      },
      {
        name: '台湾通行证',
        code: '4'
      },
      {
        name: '军官证',
        code: '5'
      },
      {
        name: '台胞证',
        code: '6'
      },
      {
        name: '回乡证',
        code: '7'
      },
      {
        name: '户口簿',
        code: '8'
      },
      {
        name: '出生证明',
        code: '9'
      }
    ]
  }

  /**
   * 联系人信息列表
   */
  static getContactInfoList() {
    return [{
      name: '邮箱',
      code: 3
    },
      {
        name: '收货地址',
        code: 4
      },
      {
        name: '身份证号',
        code: 6
      },
      {
        name: 'QQ号',
        code: 10
      },
      {
        name: '微信',
        code: 11
      },
      {
        name: '姓名',
        code: 1
      },
      {
        name: '电话',
        code: 2
      }
    ]
  }

  //定制游 预约列表状态
  static getBookstatusFilter() {
    return [{
      name: '待沟通',
      code: 0
    },
      {
        name: '沟通中',
        code: 1
      },
      {
        name: '已结束',
        code: 2
      },
      {
        name: '已成交',
        code: 3
      }
    ]
  }

  //商户类型 1运营商，2分销商
  static merchantTypeFitter() {
    return [{
      name: '运营商',
      code: 1
    },
      {
        name: '分销商',
        code: 2
      }
    ]
  }

  //商户状态
  static drawCashStatus() {
    return [{
      name: '申请中',
      code: 0
    },
      {
        name: '通过审核',
        code: 1
      },
      {
        name: '拒绝提现',
        code: 2
      },
      {
        name: '处理中(微信)',
        code: 3
      },
      {
        name: '处理中(工行)',
        code: 4
      }
    ]
  }

  /**
   * 直播状态说明：

   101直播中：表示主播正常开播，直播正常的状态

   102未开始：表示主播还未开播

   103已结束：表示在直播端点击【结束】按钮正常关闭的直播，或直播异常15分钟后系统强制结束的直播

   104禁播：表示因违规受到运营处罚被禁播

   105暂停中：表示在MP小程序后台-控制台内操作暂停了直播

   106异常：表示主播离开、切后台、断网等情况，该直播被判定为异常状态，15分钟内恢复即可回到正常直播中的状态；如果15分钟后还未恢复，直播间会被系统强制结束直播

   107已过期：表示直播间一直未开播，且已达到在MP小程序后台创建直播间时填写的直播计划结束时间，则该直播被判定为过期不能再开播
   * @returns {({code: string, name: string})[]}
   */
  static getLivePlayerStates() {
    return [{
      name: '直播中',
      code: 101
    },
      {
        name: '未开始',
        code: 102
      },
      {
        name: '已结束',
        code: 103
      },
      {
        name: '禁播',
        code: 104
      },
      {
        name: '暂停中',
        code: 105
      },
      {
        name: '异常',
        code: 106
      },
      {
        name: '已过期',
        code: 107
      }
    ]
  }

  //发票类型
  static getInvoiceType() {
    return [{
      name: '增值税电子普通发票',
      code: 1
    },
      {
        name: '增值税纸质普通发票',
        code: 2
      },
      {
        name: '增值税纸质专用发票',
        code: 3
      }
    ]
  }

  //发票状态
  static getInvoiceStatus() {
    return [{
      name: '待审核',
      code: 1
    },
      {
        name: '已开具',
        code: 2
      }
    ]
  }

  //虚拟直连订单过滤
  static getOrderDirectConnection() {
    return [{
      name: '待下单',
      code: 0
    },
      {
        name: '下单成功',
        code: 1
      },
      {
        name: '下单失败',
        code: 2
      },
      {
        name: '处理中',
        code: 3
      },
      {
        name: '建议人工处理',
        code: 4
      },
      {
        name: '已出票',
        code: 5
      },
      {
        name: '出票失败',
        code: 6
      }
    ]
  }

  //发票状态
  static getProOptionStatus() {
    return [{
      name: '下架',
      code: 0
    },
      {
        name: '上架',
        code: 1
      },
      {
        name: '删除',
        code: 2
      }
    ]
  }

  //交通列表 去程交通工具 1飞机 2火车 3汽车 4轮船 5动车 6高铁 ,
  static getTrafficList() {
    return [{
      name: '飞机',
      code: 1
    },
      {
        name: '火车',
        code: 2
      },
      {
        name: '汽车',
        code: 3
      },
      {
        name: '轮船',
        code: 4
      },
      {
        name: '动车',
        code: 5
      },
      {
        name: '高铁 ',
        code: 6
      },
      {
        name: '自理',
        code: 7
      },
      {
        name: '快艇',
        code: 8
      }
    ]
  }

  //数字转汉字
  static getChineseCharacters() {
    return [{
      name: '一',
      code: 1
    },
      {
        name: '二',
        code: 2
      },
      {
        name: '三',
        code: 3
      },
      {
        name: '四',
        code: 4
      },
      {
        name: '五',
        code: 5
      }
    ]
  }

  static getFissionStatus() {
    return [
      {
        name: '未投放',
        code: 1
      },
      {
        name: '投放中',
        code: 2
      },
      {
        name: '已结束',
        code: 3
      }
    ]
  }

  static getAuditorListStatus() {
    return [
      {
        name: '审核中',
        code: 1
      },
      {
        name: '审核成功',
        code: 2
      },
      {
        name: '审核失败',
        code: 3
      }
    ]
  }

  // 畅联订单状态   订单状态:0 待预订 1 预订中 2 预订成功 3 预订失败 4 取消订单 5 取消成功 6取消失败
  static getChangLianOrderStates() {
    return [
      {
        name: '待预订',
        code: 0
      },
      {
        name: '预订中',
        code: 1
      },
      {
        name: '预订成功',
        code: 2
      },
      {
        name: '预订失败',
        code: 3
      },
      {
        name: '取消订单',
        code: 4
      },
      {
        name: '取消成功',
        code: 5
      },
      {
        name: '6取消失败',
        code: 6
      }
    ]
  }
}
